module.exports = __webpack_public_path__ + "img/yuanmingyuan big (3).a42195e3.jpg";